export default {
  noLikesFound: 'कोई पसंद नहीं मिला',
  noMusicalGenresFound: 'अभी तक संगीत शैलियों नहीं हैं',
  noArtistsFound: 'अभी तक कलाकार नहीं हैं',
  noSongsFound: 'अभी तक गाने नहीं हैं',
  extraData: 'अतिरिक्त जानकारी',
  noExtraDataFound: 'अतिरिक्त जानकारी नहीं है',
  typeOfRegister: 'रजिस्टर का प्रकार',
  createList: 'सूची बनाएं',
  import: 'आयात',
  invitations: 'निमंत्रण',
  invite: 'आमंत्रित करना',
  seeGuests: 'मेहमानों को देखें',
  addNew: 'नया जोड़ें',
  mustChargeBeforeCreatePeople: 'लोगों को बनाने से पहले आपको पैसे वसूलने चाहिए',
  invited: 'आमंत्रित',
  verified: 'सत्यापित',
  notVerified: 'सत्यापित नहीं',
  imported: 'आयात',
  notImported: 'आयात नहीं किया गया',
  oneTimePassword: 'वन टाइम पासवर्ड',
  changePassword: 'पासवर्ड बदलें',
  deletePerson: 'व्यक्ति को हटाएं',
  loading: 'लोड',
  noPeopleRegistered: 'कोई लोग पंजीकृत नहीं',
  emailOrPhone: 'ईमेल या फोन',
  method: 'विधि',
  creationDate: 'सृजन तिथि',
  actions: 'कार्यों',
  customizedSearch: 'अनुकूलित खोज',
  state: 'राज्य',
  createPerson: 'व्यक्ति बनाएं',
  perPage: 'प्रति पृष्ठ',
  loadFile: 'लोड फाइल',
  organizeData: 'डेटा व्यवस्थित करें',
  verify: 'सत्यापित',
  pickToImportBusinessesOrPeopleToNewList: 'यदि आप व्यवसायों या लोगों को एक नई या मौजूद सूची में आयात करना चाहते हैं तो चुनें',
  pickToSavePeopleToList: 'यदि आप उन लोगों को बचाना चाहते हैं जिन्हें आप एक सूची में आयात कर रहे हैं',
  business: 'व्यापार',
  existentList: 'मौजूद सूची',
  newList: 'नई सूची',
  noList: 'सूची के बिना',
  listsNotCreated: 'आपने कोई सूची नहीं बनाई है',
  pickAList: 'एक सूची चुनें',
  typeNameOfTheList: 'सूची का नाम टाइप करें',
  uploadFileTypeInfo: 'सीएसवी या एक्सएलएक्स प्रारूप में अपने संपर्कों को सहेजे गए फ़ाइल अपलोड करें',
  pickFile: 'फाइल चुनें',
  identifyImportedFields: 'उस जानकारी के आधार पर प्रत्येक फ़ील्ड को पहचानें जिसमें यह शामिल होने जा रहा है',
  newColumnName: 'नया कॉलम नाम',
  verifyInfoBeforeListCreation: 'सूची बनाने से पहले सत्यापित करें कि जानकारी सही है',
  cancel: 'रद्द करना',
  goBack: 'पस जाओ',
  continue: 'जारी रखना',
  message: 'संदेश',
  other: 'अन्य',
  contact: 'संपर्क',
  company: 'कंपनी',
  address: 'पता',
  document: 'दस्तावेज़',
  image: 'छवि',
  location: 'स्थान',
  observation: 'अवलोकन',
  position: 'स्थिति',
  phone: 'फोन',
  phonePaste: 'फोन नंबर चिपकाने',
  phoneWrite: 'फोन नंबर लिखें',
  validPhone: 'वैध फ़ोन नंबर',
  invalidPhone: 'अमान्य फोन',
  switchPasteModePhone: 'पेस्ट-मोड फोन इनपुट पर स्विच करें',
  switchWriteModePhone: 'लिखने के लिए स्विच मोड फोन इनपुट',
  pickWhereToSavePeopleToImport: 'उठाओ. जहां लोगों को बचाने के लिए कि आप आयात करने जा रहे है',
  pleaseAddAValidFile: 'कृपया एक वैध फ़ाइल जोड़ें',
  errorReadingTheFile: 'फाइल पढ़ने में गड़बड़ी थी',
  newPerson: 'नया व्यक्ति',
  password: 'पासवर्ड',
  addNewPerson: 'नया व्यक्ति जोड़ें',
  personSuccessfullyAdded: 'व्यक्ति को सफलतापूर्वक जोड़ा गया',
  sendEmailTo: 'ईमेल भेजें',
  sendSMSTo: 'एसएमएस भेजें',
  call: 'कॉल',
  downloadContact: 'संपर्क डाउनलोड करें',
  editUser: 'उपयोगकर्ता को संपादित करें',
  know: 'जानें',
  connect: 'जोड़ना',
  emailVerify: 'ईमेल सत्यापित करें',
  talk: 'बात',
  tasks: 'कार्य',
  record: 'कार्यों',
  addPersonEmailOrPhoneToNotifyAboutTaskStatus: 'कार्य स्थिति के बारे में सूचनाएं भेजने के लिए व्यक्ति ईमेल या फ़ोन जोड़ें',
  observations: 'टिप्पणियों',
  editTask: 'कार्य संपादित करें',
  youMustAddTheNameOfTheTask: 'आपको कार्य का नाम जोड़ना होगा',
  sameNameTask: 'इस नाम के साथ एक कार्य पहले से ही मौजूद है',
  taskSuccessfullyDeleted: 'कार्य सफलतापूर्वक हटाया गया',
  noPersonNotes: 'इस उपयोगकर्ता के पास कोई सेव नोट नहीं है',
  insertNewNote: 'एक नया नोट डालें',
  currentNotes: 'सहेजे गए नोट',
  editNote: 'इस नोट को संपादित करें',
  deleteNote: 'इस नोट को हटाएं',
  errorUpdatingNotes: 'नोट अपडेट नहीं किए जा सके',
  clickPendingTasks: 'कार्य विवरण देखने के लिए क्लिक करें',
  tasksList: 'कार्य सूची',
  tasksDueToday: 'कारण आज',
  tasksDueAfter: 'कारण के बाद',
  tasksDueBefore: 'पहले कारण',
  daysRemaining: 'शेष दिन',
  extraManagementAddNewField: 'जानकारी के नए क्षेत्र जोड़ें',
  extraManagementAditionalInfo: 'आपके ब्रांड के लोगों से अतिरिक्त जानकारी',
  extraManagementItemAccessApplication: 'केवल इस आवेदन के एक व्यवस्थापक द्वारा देखा जा सकता है',
  extraManagementItemAccessPerson: 'लोगों द्वारा देखा जा सकता है',
  extraCreatorShortText: 'लघु पाठ क्षेत्र',
  extraCreatorLongText: 'बड़े टेक्स्ट फील्ड',
  extraCreatorList: 'ड्रॉपडाउन सूची',
  extraCreatorRadioList: 'रेडियो बटन सूची',
  extraCreatorCheckList: 'चेकबॉक्स सूची',
  extraCreatorEmail: 'ई मेल',
  extraCreatorCreateField: 'एक अडिशनल इंफॉर्मेशन फील्ड बनाएं',
  extraCreatorEditField: 'एक अडिशनल इंफॉर्मेशन फील्ड को एडिट करें',
  extraCreatorFieldName: 'फ़ील्ड का नाम',
  extraCreatorFieldType: 'फ़ील्ड का प्रकार',
  extraCreatorFieldAccess: 'क्षेत्र का उपयोग',
  extraCreatorAddOptions: 'विकल्प जोड़ें',
  extraCreatorOption: 'विकल्प',
  extraCreatorApplication: 'एप्लिकेशन',
  extraCreatorApplicationInfo: 'आवेदन को प्रशासक से इस फ़ील्ड की कल्पना करने और संशोधित करने की अनुमति दें',
  extraCreatorPersonInfo: 'उपयोगकर्ताओं को अपने प्रोफ़ाइल से इस फ़ील्ड की कल्पना और संशोधन करने की अनुमति देता है',
  extraCreatorAddTags: 'कुछ टैग जोड़ें',
  extraCreatorMessageEnterTag1: 'कोई परिणाम मिलान नहीं',
  extraCreatorMessageEnterTag2: 'दबाना',
  extraCreatorMessageEnterTag3: 'एक नया बनाने के लिए',
  setResponsible: 'एक जिम्मेदार सेट करें',
  assign: 'सौंपना',
  selectResponsible: 'नए उपयोगकर्ताओं की इस सूची के लिए जिम्मेदार चुनें',
  pickAResponsible: 'एक जिम्मेदार चुनें',
  selectResponsibleSolo: 'इस उपयोगकर्ता के लिए एक जिम्मेदार चुनें',
  seeLess: 'कम देखें',
  favoriteSongs: 'पसंदीदा गाने',
  favoriteMusicalGenres: 'पसंदीदा संगीत शैलियों',
  favoriteArtists: 'पसंदीदा कलाकार',
  noInstagramSpotifyTags: 'अभी तक Instagram या Spotify प्राथमिकताएं नहीं हैं',
  addToList: 'सूची में जोड़ें',
  noPersonRecords: 'इस उपयोगकर्ता के पास कोई क्रिया रिकॉर्ड नहीं है',
  personAddedToList: 'सूची में जोड़ा गया व्यक्ति',
  messageSuccessfullySent: 'सफलतापूर्वक भेजा गया संदेश',
  loadCsv: 'लोड सीएसवी',
  insertInvitedPeopleEmailPhone: 'उन लोगों के सभी ईमेल या फोन डालें जिन्हें आप अल्पविराम से अलग आमंत्रित करना चाहते हैं',
  noEmail: 'ईमेल के बिना',
  noPhone: 'फोन के बिना',
  noLoadedInvitations: 'कोई लोडेड निमंत्रण नहीं',
  downloadCsv: 'सीएसवी डाउनलोड करें',
  invitePerson: 'व्यक्ति को आमंत्रित करें',
  inviteAdministrator: 'प्रशासक को आमंत्रित करें',
  invitedPeople: 'लोगों को आमंत्रित किया',
  sendSms: 'एसएमएस भेजें',
  resendInvitations: 'निमंत्रण फिर से भेजना',
  noInvitationsSent: 'कोई निमंत्रण नहीं भेजा गया',
  noAssistantSelected: 'आपने किसी सहायक का चयन नहीं किया है',
  thisEmailIsGoingToBeSentTo: 'इस ईमेल को भेजा जा रहा है',
  assistants: 'सहायकों',
  noPersonSelected: 'आपने किसी भी व्यक्ति का चयन नहीं किया है',
  allTheEventAssistants: 'सभी {घटना} सहायकों',
  close: 'बंद करना',
  send: 'भेजें',
  accept: 'स्वीकार करना',
  actualPassword: 'वास्तविक पासवर्ड',
  change: 'बदल',
  youAreAboutToChangeUserPassword: 'आप {उपयोगकर्ता का पासवर्ड बदलने वाले हैं। व्यक्ति को नया पासवर्ड बताना याद रखें',
  saveChanges: 'परिवर्तनों को सहेजें',
  onetimePasswordUse: 'इस पासवर्ड का उपयोग केवल एक बार किया जा सकता है',
  sendToPersonEmail: 'किसी व्यक्ति के ईमेल पर भेजें',
  sendToPersonPhone: 'व्यक्ति के फोन पर भेजें',
  generatePassword: 'पासवर्ड जेनरेट करें',
  passwordCopiedToClipboard: 'पासवर्ड क्लिपबोर्ड को कॉपी किया गया है',
  errorCopyingThePassword: 'पासवर्ड की नकल करने में त्रुटि',
  doYouWantToDeleteThisPerson: 'क्या आप इस व्यक्ति को हटाना चाहते हैं?',
  personSuccessfullyDeleted: 'व्यक्ति को सफलतापूर्वक हटाया गया',
  selectFinishingDate: 'फिनिशिंग डेट चुनें',
  pick: 'लेना',
  selectFinishingHour: 'फिनिशिंग ऑवर चुनें',
  createTask: 'कार्य बनाएँ',
  currentTasks: 'वर्तमान कार्य',
  noTasksToDo: 'ऐसा करने के लिए कार्य नहीं हैं',
  hour: 'घंटा',
  date: 'दिनांक',
  moveToDoneTasks: 'कार्यों के लिए कदम',
  deleteTask: 'टास्क हटाएं',
  completedTasks: 'पूरा कार्य',
  noCompletedTasks: 'पूरे कार्य नहीं हैं',
  moveToUndoneTasks: 'पूर्ववत कार्यों के लिए कदम',
  errorUpdatingTasks: 'कार्यों को अपडेट नहीं कर सका',
  enterTheNameAndDescriptionOfTheTask: 'कार्य का नाम और अवलोकन दर्ज करें',
  insertANewTask: 'एक नया कार्य डालें',
  editProfile: 'प्रोफाइल को संपादित करें',
  insertFullName: 'अपना पूरा नाम डालें',
  insertYourEmail: 'अपना ईमेल डालें',
  addRoles: 'भूमिकाएं जोड़ें',
  description: 'विवरण',
  userDescription: 'उपयोगकर्ता विवरण',
  notes: 'नोट्स',
  addCommentsAboutThisPerson: 'इस व्यक्ति के बारे में टिप्पणियां जोड़ें',
  noInformation: 'कोई जानकारी नहीं',
  updatedCorrectly: 'सही ढंग से अपडेट किया गया',
  searchCountry: 'खोज देश',
  countryNotFound: 'देश नहीं मिला',
  uploadDocument: 'दस्तावेज़ अपलोड करें',
  downloadDocument: 'दस्तावेज़ डाउनलोड करें',
  editDocument: 'दस्तावेज़ संपादित करें',
  deleteDocument: 'दस्तावेज़ हटाएं',
  documents: 'दस्तावेज़',
  deleteDocumentConfirmation: 'क्या आप वास्तव में इस दस्तावेज़ को हटाना चाहते हैं?',
  insertDocumentDescription: 'दस्तावेज़ विवरण दर्ज करें',
  editDescription: 'विवरण संपादित करें',
  documentSuccessfullyDeleted: 'दस्तावेज़ सफलतापूर्वक हटाया गया',
  youMustPickADocumentToEdit: 'आपको संपादित करने के लिए दस्तावेज़ चुनना होगा',
  fileSizeMustBeUnderXSize: 'संलग्न फ़ाइल का आकार {आकार के तहत होना चाहिए',
  documentSuccessfullyEdited: 'दस्तावेज़ सफलतापूर्वक हटाया गया',
  documentSuccessfullyUploaded: 'दस्तावेज़ सफलतापूर्वक अपलोड किया गया',
  editList: 'सूची संपादित करें',
  listCorrectlyUpdated: 'सूची सही ढंग से अपडेट की गई',
  personDeletedFromList: 'सूची से हटाया गया व्यक्ति',
  doYouWantToDeleteThisList: 'क्या आप इस सूची को हटाना चाहते हैं',
  deleteList: 'सूची हटाएं',
  listDeleted: 'सूची हटाई गई',
  lists: 'सूचियाँ',
  create: 'बनाना',
  campaign: 'अभियान',
  peopleLists: 'लोगों की सूचियां',
  peopleListsNotCreated: 'आपने किसी भी लोगों की सूची नहीं बनाई है',
  peopleInTheList: 'सूची में लोग',
  listName: 'सूची का नाम',
  waitUntilTheListGetsCreated: 'सूची बनाए जाने तक प्रतीक्षा करें',
  loadingPeopleFromTheList: 'सूची से लोगों को लोड',
  noPeopleInThisList: 'इस सूची में लोग नहीं हैं',
  rolesNotCreated: 'नहीं बनाई गई भूमिकाएं',
  code: 'कोड',
  nameOfTheRol: 'रोल का नाम',
  newRol: 'नई रोल',
  addNewRol: 'नया रोल जोड़ें',
  rolSuccessfullyCreated: 'रोल सफलतापूर्वक बनाया',
  editRol: 'रोल संपादित करें',
  rolSuccessfullyEdited: 'रोल सफलतापूर्वक संपादित',
  columnsTable: 'कॉलम',
  edit: 'संपादित करने के लिए',
  loadingPerson: 'व्यक्ति को लोड कर रहा है',
  weCouldNotFindThisPerson: 'हमें यह व्यक्ति नहीं मिला',
  youMustAddKeyToUpdateUser: 'आपको इस व्यक्ति को अपडेट करने के लिए एक कुंजी जोड़ना चाहिए',
  noDocumentsWereFoundForThisPerson: 'इस व्यक्ति से जुड़े दस्तावेज़ अपलोड नहीं किए गए हैं',
  email: 'ईमेल',
  verifyEmail: 'ईमेल सत्यापित करें',
  roles: 'भूमिकाएँ',
  updateAppPublicKey: 'एप्लिकेशन सार्वजनिक कुंजी अपडेट करें',
  emailSuccessfullyVerified: 'ईमेल सफलतापूर्वक सत्यापित की गई',
  closeProfile: 'करीबी प्रोफ़ाइल',
  journey: 'यात्रा',
  noJourneyForCurrentApp: 'आपके आवेदन में संबद्ध यात्रा नहीं है, इस व्यक्ति की वर्तमान यात्रा स्थिति को जोड़ने या बदलने के लिए एक बनाएं',
  changeJourneyCurrentStatus: 'इस व्यक्ति की यात्रा वर्तमान स्थिति बदलें',
  dependsOn: 'निर्भर करता है',
  isDependencyOf: 'की निर्भरता है',
  changeJourneyCurrentStatusWarning: 'क्या आप इस व्यक्ति की वर्तमान स्थिति को बदलना सुनिश्चित कर रहे हैं?',
  changeJourneyStatus: 'यात्रा की वर्तमान स्थिति बदलें',
  customFields: 'कस्टम फील्ड्स',
  seeFilters: 'फ़िल्टर देखें',
  hideFilters: 'फ़िल्टर छिपाएँ',
  peopleFilters: 'लोगों के फिल्टर',
  clearFields: 'खेतों को साफ करें',
  startEditingMode: 'संपादन मोड प्रारंभ करें',
  stopEditingMode: 'संपादन मोड बंद करो',
  createNewTaskToAssignInBlock: 'ब्लॉक में असाइन करने के लिए नया कार्य बनाएँ',
  taskCreatedSuccessfully: 'टास्क सफलतापूर्वक बनाया गया',
  chooseTheTypeOfBlockEdition: 'ब्लॉक संपादन के प्रकार का चयन करके शुरू करें जो आप प्रक्रिया शुरू करने के लिए करना चाहते हैं',
  modifyTheAdditionalDataThatYouWant: 'इच्छित अतिरिक्त डेटा को संशोधित करें',
  justTheFilledExtraDataAreGoingToBeChanged: 'केवल कुछ जानकारियों से भरे अतिरिक्त डेटा को संपादित किया जाएगा, बाकी सभी को नजरअंदाज किया जाएगा',
  pickTheJourneyStatusToAssignInBlock: 'ब्लॉक में असाइन करने के लिए जर्नी स्टेटस चुनें',
  editInBlock: 'ब्लॉक में संपादित करें',
  enterInformation: 'जानकारी दर्ज करें',
  modifyAtLeastOneExtraDataToEditInBlock: 'ब्लॉक में संपादित करने में सक्षम होने के लिए आपको कम से कम एक अतिरिक्तडाटा को संशोधित करना होगा',
  addAJourneyStatusToEditInBlock: 'ब्लॉक में इसे संपादित करने के लिए आपको एक जर्नी स्टेटस जोड़ना होगा',
  createAValidTaskToAddInBlock: 'इसे ब्लॉक में जोड़ने के लिए आपको एक मान्य कार्य बनाना होगा',
  editPeopleInBlock: 'ब्लॉक में लोगों को संपादित करें',
  aListWithThisNameAlreadyExists: 'इस नाम की एक सूची पहले से मौजूद है',
  addTheNameOfTheListToBeCreated: 'बनाई जाने वाली सूची का नाम जोड़ें',
  changeExtraData: 'अतिरिक्त जानकारी बदलें',
  pickAtLeastOneTypeOfEditingToEditInBlock: 'आपको कम से कम एक प्रकार का संपादन करना होगा और संबंधित जानकारी को भरना होगा',
  editInBlockFinishedSuccessfully: 'ब्लॉक में संपादित सफलतापूर्वक पूरा हुआ',
  youMustAddTagsInOrderToFilterExtraData: 'इसे टैग द्वारा फ़िल्टर करने के लिए आपको अतिरिक्त डेटा में टैग जोड़ना होगा',
  menu: 'मेन्यू',
  of: 'का',
  responsible: 'उत्तरदायी',
  addPersonToBusiness: 'व्यक्ति को व्यवसाय से जोड़ें',
  businessSuccessfullyAdded: 'व्यवसाय सफलतापूर्वक जोड़ा गया',
  enterPersonPositionInBusiness: 'व्यवसाय में व्यक्ति की स्थिति दर्ज करें',
  searchABusinessToAdd: 'जोड़ने के लिए एक व्यवसाय खोजें',
  thisPersonHasNoBusinesses: 'इस व्यक्ति का कोई व्यवसाय नहीं है',
  fullName: 'पूरा नाम',
  firstName: 'पहला नाम',
  onlyStaticListsAreListedBelow: 'केवल स्थैतिक सूची नीचे सूचीबद्ध हैं',
  listType: 'सूची प्रकार',
  static: 'स्थिर',
  dynamic: 'गतिशील',
  mainPhone: 'मुख्य फ़ोन',
  profile: 'प्रोफ़ाइल',
  orderExtraData: 'अतिरिक्त डेटा ऑर्डर करें',
  tags: 'टैग',
  noTags: 'टैग के बिना',
  privacyTermsWarning: 'डेटा निर्यात करना अच्छा व्यवहार नहीं है क्योंकि यह कानून 1581 और GDPR का उल्लंघन कर सकता है। क्या आप वाकई डेटा निर्यात करना चाहते हैं?',
  registerName: 'नाम पंजीकृत करें?',
  sendEmail: 'ईमेल भेजें',
  editResponsible: 'जिम्मेदार संपादित करें',
  permissionsFor: 'के लिए अनुमतियाँ',
  // Importing people info
  numberOfRows: 'पंक्तियों की संख्या',
  totalPeople: 'कुल लोग',
  uniquePeople: 'अनोखे लोग',
  savedPeople: 'लोगों को बचाया',
  updatedPeople: 'अपडेट किए गए लोग',
  insertedPeople: 'सम्मिलित लोग',
  duplicatedPeople: 'डुप्लीकेट लोग',
  importCompleted: 'आयात पूरा हुआ',
  importingBusinesses: 'व्यापार का आयात करना',
  creatingList: 'सूची बनाना',
  peopleRegistrationInformation: 'चयनित अवधि के लिए लोगों की पंजीकरण जानकारी',
  businessInformationItems: 'व्यापार जानकारी कॉलम',
  personalInformationItems: 'व्यक्तिगत जानकारी कॉलम',
  extraDataItems: 'अतिरिक्त जानकारी कॉलम',
  doYouWantToDeleteThisRol: 'आप वास्तव में इस रोल को हटाना चाहते हैं',
  rolSuccessfullyDeleted: 'रोल सफलतापूर्वक हटा दिया गया',
  addSelectedUsersToList: 'सूची में चयनित उपयोगकर्ता जोड़ें',
  usersSuccessfullyAddedToList: 'उपयोगकर्ताओं को सफलतापूर्वक सूची में जोड़ा गया'
}
